import {Sound} from '../../../shared/scripts/Sound'
import {CA} from '../../../shared/scripts/analytics/Analytics'
import {setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import {UIAdElements} from './UIAdElements'
import {UIHomepageAdView} from '../ui_html/home_page/UIHomepageAdView'
import {ArrayUtils} from '../../../../shared/utils/ArrayUtils'
import {ViewPopupLogin} from '../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin'
import {ClientUserState} from '../../../shared/scripts/ClientUserState'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {HolidayDateUtils, HolidayKey} from '../../../shared/scripts/HolidayDateUtils'
import {ImageURL, TimeoutId} from '@colonist/types'
import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {AnalyticEventCategory, AnalyticEventType, GiftMembershipMethod} from '../../../../shared/entity_datas/EntityDatas'
import {navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils.ts'
import AbFullscreen from '@static/images/ab_fullscreen.png'
import AbMembership from '@static/images/ab_membership.png'
import AbCkRanked from '@static/images/ab_ck_ranked.png'
import AbProfileRanked from '@static/images/ab_profile_ranked.png'
import AbSignIn from '@static/images/ab_sign_in.png'
import AbDiscordLogin from '@static/images/ab_discordlogin.png'
import AbMobileApp from '@static/images/ab_mobileapp.png'
import AbJoin from '@static/images/ab_join.png'
import AbHiringUx from '@static/images/ab_hiring_ux.png'
import AbGiftingValentines from '@static/images/ab_gifting_valentines.png'
import AbGiftingEaster from '@static/images/ab_gifting_easter.png'
import AbGiftingHalloween from '@static/images/ab_gifting_halloween.png'
import AbGiftingThanksgiving from '@static/images/ab_gifting_thanksgiving.png'
import AbGiftingChristmas from '@static/images/ab_gifting_christmas.png'
import AbGifting from '@static/images/ab_gifting.png'
import AbQualifier from '@static/images/ab_qualifier.png'

export interface PrivateAdOptions {
    filterIfLoggedIn?: boolean
    filterIfDiscord?: boolean
    filterIfMembership?: boolean
    filterIfNotDiscord?: boolean
}

interface AdBlockPrivateAd extends PrivateAdOptions {
    imageUrl: ImageURL
    targetUrl: string
    onClick?: () => void
    clickAnalytic?: GiftMembershipMethod
    giftingAd?: boolean
}

export class UIPrivateAdController {
    private ads: AdBlockPrivateAd[] = [
        {imageUrl: AbFullscreen, targetUrl: '/store#membership', filterIfDiscord: true},
        {imageUrl: AbMembership, targetUrl: '/store'},
        // {imageUrl: AbContributor, targetUrl: '/careers'},
        {imageUrl: AbCkRanked, targetUrl: '/leaderboards/CitiesAndKnights4P/'},
        {imageUrl: AbProfileRanked, targetUrl: '/leaderboards'},
        {imageUrl: AbSignIn, targetUrl: '', onClick: () => new ViewPopupLogin(), filterIfLoggedIn: true, filterIfDiscord: true},
        {imageUrl: AbDiscordLogin, targetUrl: '', onClick: () => new ViewPopupLogin(), filterIfLoggedIn: true, filterIfDiscord: true},
        {imageUrl: AbMobileApp, targetUrl: 'https://apps.apple.com/us/app/colonist-io/id6444831129'},
        {imageUrl: AbJoin, targetUrl: 'https://colonist.io/careers'},
        // {imageUrl: AbHiringPm, targetUrl: '/roles/product'},
        // {imageUrl: AbHiringQa, targetUrl: '/roles/qa-tester'},
        {imageUrl: AbHiringUx, targetUrl: '/careers'},
        // {imageUrl: AbTournament, targetUrl: 'https://www.youtube.com/@colonistio/?sub_confirmation=1'},
        {imageUrl: AbQualifier, targetUrl: '/championship25'},
    ]

    private readonly UPDATE_AD_DURATION = 1000 * 60
    private imageElements: HTMLImageElement[] = []

    private timer: TimeoutId
    private readonly adElements: UIAdElements
    private readonly lobbyLeftStoreAd: UIHomepageAdView
    private readonly lobbyRightStoreAd: UIHomepageAdView
    private showingAds: boolean

    constructor(adElements: UIAdElements) {
        this.adElements = adElements
        this.lobbyLeftStoreAd = new UIHomepageAdView(true)
        this.lobbyRightStoreAd = new UIHomepageAdView(false)

        this.setGiftingAdBanners()
    }

    startRefreshing() {
        if(this.showingAds) return
        this.showingAds = true
        this.createColonistAds()
        this.updateColonistAds()
        this.updateStoreAds()
        this.timer = setInterval(() => {
            this.updateColonistAds()
            this.updateStoreAds()
        }, this.UPDATE_AD_DURATION)
    }

    private updateColonistAds() {
        for(const imageElement of this.imageElements) {
            this.ads = UIPrivateAdController.filterAds(this.ads)
            const adInformation = ArrayUtils.randomElementFromArray(this.ads)
            imageElement.src = adInformation.imageUrl
            setElementOnClick(imageElement, () => {
                CA.sendGoogleAnalyticsEvent(CA.Category.Lobby, CA.Label.ClickedAdblockAd)
                Sound.playSound(Sound.SoundType.Click)

                if(adInformation.clickAnalytic != undefined) {
                    const eventData: AjaxDataTypes.AnalyticData = {
                        type: AnalyticEventType.ABTestClickAnalytics,
                        category: adInformation.giftingAd ? AnalyticEventCategory.GiftMembershipOverlay : AnalyticEventCategory.ABTestClickAnalytics,
                        floatValue: adInformation.clickAnalytic,
                    }
                    void CA.sendAnalyticEvent(eventData)
                }

                if(adInformation.onClick != undefined) {
                    adInformation.onClick()
                    return
                }
                navigateToPage(adInformation.targetUrl, true)
            })
        }
    }

    private createColonistAds() {
        this.lobbyLeftStoreAd.show()
        this.lobbyRightStoreAd.show()
        this.createAd(this.adElements.containerGameRight, 160, 600, '')
        this.createAd(this.adElements.containerGameLeft, 160, 600, '')
        UIPrivateAdController.hideNewLayoutVerticalAdContainers()
    }

    private static hideNewLayoutVerticalAdContainers() {
        const newLayoutAdSpace = document.getElementById('new-layout-ad-space')
        if(newLayoutAdSpace == undefined) return

        newLayoutAdSpace.querySelectorAll('.lobby_vertical_ab')
            .forEach((element) => element.classList.add('hidden'))
    }

    private updateStoreAds() {
        this.lobbyLeftStoreAd.update()
        this.lobbyRightStoreAd.update()
    }

    private createAd(container: HTMLDivElement, width: number, height: number, id: string) {
        if(container === null) return

        const imgElement = document.createElement('img')
        container.append(imgElement)
        imgElement.width = width
        imgElement.height = height
        imgElement.id = id
        imgElement.style.cursor = 'pointer'
        this.imageElements.push(imgElement)
    }

    removeAds() {
        if(!this.showingAds) return
        this.showingAds = false
        this.lobbyLeftStoreAd.hide()
        this.lobbyRightStoreAd.hide()
        clearInterval(this.timer)
        for(const element of this.imageElements) {
            if(element.parentElement == undefined) continue
            element.parentElement?.removeChild(element)
        }
        this.imageElements = []
    }

    static filterAds<T extends PrivateAdOptions>(list: T[]): T[] {
        if(ClientUserState.userState?.isLoggedIn) list = list.filter((item: T) => item.filterIfLoggedIn != true)
        if(UIUtilsEjsVariables.isUserOnDiscord) list = list.filter((item: T) => item.filterIfDiscord != true)
        if(ClientUserState.userState?.items.hasMembership()) list = list.filter((item: T) => item.filterIfMembership != true)
        if(!UIUtilsEjsVariables.isUserOnDiscord) list = list.filter((item: T) => item.filterIfNotDiscord != true)
        return list
    }

    static accountLinkingAction() {
        if(ClientUserState.userState?.isLoggedIn) {
            const profileRoute = `/profile/${ClientUserState.userState.username}#settings`
            navigateToPage(profileRoute, true)
            return
        }
        new ViewPopupLogin()
    }

    private setGiftingAdBanners() {
        const targetUrl = '/store#gift'
        const holiday: HolidayKey | undefined = HolidayDateUtils.getCurrentHoliday()
        switch(holiday) {
            case 'valentines': {
                this.ads.push({imageUrl: AbGiftingValentines, targetUrl: targetUrl, giftingAd: true, clickAnalytic: GiftMembershipMethod.InGameAd})
                break
            }
            case 'easter': {
                this.ads.push({imageUrl: AbGiftingEaster, targetUrl: targetUrl, giftingAd: true, clickAnalytic: GiftMembershipMethod.InGameAd})
                break
            }
            case 'halloween': {
                this.ads.push({imageUrl: AbGiftingHalloween, targetUrl: targetUrl, giftingAd: true, clickAnalytic: GiftMembershipMethod.InGameAd})
                break
            }
            case 'thanksgiving': {
                this.ads.push({imageUrl: AbGiftingThanksgiving, targetUrl: targetUrl, giftingAd: true, clickAnalytic: GiftMembershipMethod.InGameAd})
                break
            }
            case 'christmas': {
                this.ads.push({imageUrl: AbGiftingChristmas, targetUrl: targetUrl, giftingAd: true, clickAnalytic: GiftMembershipMethod.InGameAd})
                break
            }
            default: break
        }
        this.ads.push({imageUrl: AbGifting, targetUrl: targetUrl, giftingAd: true, clickAnalytic: GiftMembershipMethod.InGameAd})
    }
}
